const ranking = [
  {
    rank: 1,
    title: '暗夜追凶',
    tag: '悬疑',
    score: '9.2',
    desc: '层层反转的国产悬疑神作',
  },
  {
    rank: 2,
    title: '铁血战狼',
    tag: '动作',
    score: '9.0',
    desc: '硬核军事动作，全程无尿点',
  },
  {
    rank: 3,
    title: '星海征途',
    tag: '科幻',
    score: '8.9',
    desc: '国产科幻新标杆，视觉震撼',
  },
  {
    rank: 4,
    title: '云端之上',
    tag: '文艺',
    score: '8.8',
    desc: '治愈系文艺佳作，好评如潮',
  },
  {
    rank: 5,
    title: '笑傲江湖',
    tag: '喜剧',
    score: '8.7',
    desc: '全明星喜剧阵容，爆笑不断',
  },
  {
    rank: 6,
    title: '长安十二夜',
    tag: '历史',
    score: '8.6',
    desc: '盛唐气象，匠心历史巨制',
  },
  {
    rank: 7,
    title: '山河纪行',
    tag: '纪录片',
    score: '8.5',
    desc: '壮丽山河中的人文故事',
  },
];

function RankBadge({ rank }: { rank: number }) {
  const colors = [
    'bg-accent-500 text-background-50',
    'bg-secondary-500 text-background-50',
    'bg-accent-700 text-background-50',
  ];
  return (
    <span
      className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-bold ${
        rank <= 3 ? colors[rank - 1] : 'bg-background-200 text-foreground-600'
      }`}
    >
      {rank}
    </span>
  );
}

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            热门榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            本周最受关注的国产电影排行榜，看看大家都在看什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-0">
          {ranking.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-3.5 md:py-4 border-b border-background-200/70 last:border-b-0 cursor-pointer hover:bg-background-100/70 transition-colors px-3 rounded-lg"
            >
              <RankBadge rank={item.rank} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm md:text-base font-heading font-bold text-foreground-950 truncate">
                    {item.title}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 flex items-center gap-1">
                <span className="flex items-center justify-center w-4 h-4">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                </span>
                <span className="text-sm font-bold text-accent-600">{item.score}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}